import { useReduxContext } from "./useReduxContext";

export function useSelector(selector) {
  if (typeof selector !== "function") {
    throw new Error(`You must pass a function as a selector to useSelector`);
  }
  const { state } = useReduxContext();
  return () => selector(state);
}
